import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { openRootModalWithDialog } from '@/checkout-instore-legacy/rootModal/actions'
import { actionCreators } from '@/checkout-instore-legacy/returnExchange/actions'

import ExchangeClient from '../components/ExchangeClient'

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...actionCreators, openRootModalWithDialog }, dispatch)

const mapStateToProps = (state) => ({
  giftcardLoading: state.returnExchange.giftcardLoading,
  order: state.returnExchange.order,
})

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeClient)
